 var acc = document.getElementsByClassName('accordion-toggle-container');
 
 var i;
 
 for (i = 0; i < acc.length; i++) {
   acc[i].addEventListener('click', function(evt) {
     this.classList.toggle('open');
     var panel = this.previousElementSibling;
     
     if (panel.style.maxHeight === '3000px') {
       panel.style.maxHeight = '0';
       panel.style.paddingBottom = '0';
       evt.target.setAttribute('aria-expanded','false');
     } else {
       panel.style.maxHeight = '3000px';
       panel.style.paddingBottom = '50px';
       evt.target.setAttribute('aria-expanded','true');
     }
   });
 }